import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType, RLocalApplicationIdRef} from './apiTypes';

/*
 * Constants.
 */

export enum LocalApplicationChannelTypeContactTypesEnum {
  CUSTOM = 'custom',
  EMAIL = 'email',
  PHONE = 'phone',
}
export const RLocalApplicationChannelTypeContactType = makeEnumRuntimeType(
  LocalApplicationChannelTypeContactTypesEnum,
);

export enum LocalApplicationChannelTypeComposeModesEnum {
  NORMAL = 'normal',
  UNSUPPORTED = 'unsupported',
}
export const RLocalApplicationChannelTypeComposeMode = makeEnumRuntimeType(
  LocalApplicationChannelTypeComposeModesEnum,
);

export enum LocalApplicationChannelTypeReplyModesEnum {
  SAME_CHANNEL = 'same_channel',
  UNSUPPORTED = 'unsupported',
}
export const RLocalApplicationChannelTypeReplyMode = makeEnumRuntimeType(
  LocalApplicationChannelTypeReplyModesEnum,
);

export enum LocalApplicationChannelTypeComposerTypesEnum {
  BASIC = 'basic',
  ADVANCED = 'advanced',
}
export const RLocalApplicationChannelTypeComposerType = makeEnumRuntimeType(
  LocalApplicationChannelTypeComposerTypesEnum,
);

/*
 * Runtime types.
 */

const RLocalApplicationChannelTypeSettings = t.readonly(
  t.type({
    composeMode: RLocalApplicationChannelTypeComposeMode,
    composerType: RLocalApplicationChannelTypeComposerType,
    contactType: RLocalApplicationChannelTypeContactType,
    replyMode: RLocalApplicationChannelTypeReplyMode,
    supportedAttachmentTypes: t.readonlyArray(t.string),
    supportsImportedMessageNotifications: t.boolean,
  }),
);

const RLocalApplicationChannelTypeDirty = t.readonly(
  t.intersection([
    t.type({
      id: t.Integer,
      uid: t.string,
      localApplicationId: RLocalApplicationIdRef,
      webhookUrl: t.string,
      settings: RLocalApplicationChannelTypeSettings,
      createdAt: t.Integer,
      updatedAt: t.Integer,
    }),
    t.partial({
      description: t.string,
    }),
  ]),
);

/*
 * Types.
 */

export interface LocalApplicationChannelTypeModel
  extends t.TypeOf<typeof RLocalApplicationChannelTypeDirty> {}
export interface LocalApplicationChannelTypeSettingsModel
  extends t.TypeOf<typeof RLocalApplicationChannelTypeSettings> {}
export const RLocalApplicationChannelType = t.clean<LocalApplicationChannelTypeModel>(
  RLocalApplicationChannelTypeDirty as any,
);

/*
 * IO methods.
 */

export function parseLocalApplicationChannelType(src: any): LocalApplicationChannelTypeModel {
  return {
    id: src.id,
    uid: src.channel_type_uid,
    localApplicationId: src.local_application_id,
    description: src.description,
    webhookUrl: src.webhook_url,
    settings: parseLocalApplicationChannelTypeSettings(src.settings),
    createdAt: src.created_at,
    updatedAt: src.updated_at,
  };
}

export function parseLocalApplicationChannelTypeSettings(src: any): LocalApplicationChannelTypeSettingsModel {
  return {
    composeMode: src.compose_mode,
    composerType: src.composer_type,
    contactType: src.contact_type,
    replyMode: src.reply_mode,
    supportedAttachmentTypes: src.supported_attachment_types,
    supportsImportedMessageNotifications: src.supports_imported_message_notifications,
  };
}

/*
 * API types.
 */

export const ApiLocalApplicationChannelType = makeApiType(
  'localApplicationChannelType',
  RLocalApplicationChannelType,
  parseLocalApplicationChannelType,
);
